import React, { useEffect, useState } from "react";
import Modal from "react-modal"; 
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import ErrorModal from "../Security/ErrorModal";
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from 'react-i18next';
Modal.setAppElement('#root');


const ProviderFormModal = ({ isOpen, onClose , providerType ,NoOfMarkers}) => {
  const { t, i18n } = useTranslation();
  const [formData, setFormData] = useState({
    GroupName: '',
    ProviderName: '',
    Address: '',
    PointofContact: '',
    ProviderEmail: '',
    ProviderPhoneNumber: '',
    Website: '',
    FirstName: '',
    LastName: '',
    DOB: '',
    PhoneNumber:'',
    EmailID: '',
  });
  
  const [responseMessage, setResponseMessage] = useState('');
  const userInfo = useSelector((state) => state.userData);
  const token = localStorage.getItem('AccessToken');
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [errors, setErrors] = useState({});
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
     // Allow only numeric characters for phone number fields
  if (name === 'ProviderPhoneNumber' || name === 'PhoneNumber') {
    // Replace any non-numeric characters with an empty string
    const numericValue = value.replace(/\D/g, '');
    setFormData({ ...formData, [name]: numericValue });
  } else {
    setFormData({ ...formData, [name]: value });
  }
  };
  useEffect(() => {
  if (isOpen) {
    setFormData({
      GroupName: '',
      ProviderName: '',
      Address: '',
      PointofContact: '',
      ProviderEmail: '',
      ProviderPhoneNumber: '',
      Website: '',
      FirstName: userInfo?.userData?.FirstName || "",
      LastName: userInfo?.userData?.LastName || "",
      DOB: userInfo?.userData?.DOB
        ? (() => {
            const dobParts = userInfo.userData.DOB.split('/');
            return dobParts.length === 3
              ? `${dobParts[2]}-${dobParts[0].padStart(2, '0')}-${dobParts[1].padStart(2, '0')}`
              : "";
          })()
        : "",
      PhoneNumber: userInfo?.userData?.MobileNumber || "",
      EmailID: userInfo?.userData?.EmailID || "",
    });
    setErrors({});
    setModalMessage("");
    setResponseMessage("");
  }
}, [isOpen, userInfo]);
   // Initialize formData with userInfo
   useEffect(() => {
    if (userInfo) {
      // Convert DOB from MM/DD/YYYY to YYYY-MM-DD
      const dobParts = userInfo.userData.DOB?.split('/');
      const formattedDOB = dobParts && dobParts.length === 3
        ? `${dobParts[2]}-${dobParts[0].padStart(2, '0')}-${dobParts[1].padStart(2, '0')}`
        : "";
      setFormData((prevData) => ({
        ...prevData,
        FirstName: userInfo.userData.FirstName || "",
        LastName: userInfo.userData.LastName || "",
        DOB: formattedDOB,
        PhoneNumber: userInfo.userData.MobileNumber || "",
        EmailID: userInfo.userData.EmailID || "",
      }));
    }
  }, [userInfo]);

  const validateForm = () => {
    const newErrors = {};
   if ( NoOfMarkers !== 0 ) {
    if ((!formData.GroupName.trim()) && (!formData.ProviderName.trim())) {
      newErrors.GroupName = "Please enter either Name of Group or Name of Provider within group";
    }
  }
    // if (!formData.GroupName.trim()) newErrors.GroupName = "Please enter either Name of Group or Name of Provider within group"; /*t('groupnamerequired');*/
    // if (!formData.ProviderName.trim()) newErrors.ProviderName = "Please enter either Name of Group or Name of Provider within group";/*t('providernamerequored');*/
    // if (!formData.Address.trim()) newErrors.Address = t('addressrequired');
    // if (!formData.PointofContact.trim()) newErrors.PointofContact = t('pointofcontact');
//     if (!formData.ProviderEmail.trim()) {
//       newErrors.ProviderEmail = t('provideremail');
//     } else if (!/\S+@\S+\.\S+/.test(formData.ProviderEmail)) {
//   newErrors.ProviderEmail = "invalid email";
// }
    // if (!formData.ProviderPhoneNumber.trim()) newErrors.ProviderPhoneNumber = t('providerphonenumber');
    if (!formData.FirstName.trim()) newErrors.FirstName = t('firstnamerequired');
    if (!formData.LastName.trim()) newErrors.LastName = t('lastnamerequired');
    if (!formData.DOB.trim()) newErrors.DOB = t('dateofbirthrequired');
    if (!formData.PhoneNumber.trim()) newErrors.PhoneNumber = t('phonenumberrequired');
    if (!formData.EmailID.trim()) {
      newErrors.EmailID = t('emailrequired');
    } else if (!/\S+@\S+\.\S+/.test(formData.EmailID)) {
      newErrors.EmailID = t('invalidemail');
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return; // Stop submission if validation fails
    }
    try {

          // Create a copy of formData to modify DOB format
    const formattedFormData = { ...formData };

    // Check if DOB is present and format it to MM/DD/YYYY
    if (formattedFormData.DOB) {
      const [year, month, day] = formattedFormData.DOB.split('-');
      formattedFormData.DOB = `${month}/${day}/${year}`;
    }
        const params = {
            ...formattedFormData,
            ProviderType: providerType,
            MemberID: userInfo.userData.MemberID,
            Contract: userInfo.userData.ContractIdentified,
            DeviceType:isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
            EmailID:userInfo.userData.EmailID,
            IsUrgent: NoOfMarkers === 0 ? "Yes" : "No",
          };
    console.log("param:",params)
    setLoading(true);
      const response = await axios.post(Endpoints.SaveProviderDetails,
        { _Params: JSON.stringify(params) },
        {
          headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "Connection": "close",
              "Accept": "*/*",
              Authorization: `Bearer ${token}`,
            },
          }
      );
            const result = response.data;
            setResponseMessage(result.Message);

      if (result.Result === 1) {
        if (NoOfMarkers === 0) setModalMessage(
            `Thanks for your suggestion!
            
        We will contact you shortly to discuss your available options.`
          );
          else setModalMessage(
            `Thanks for your suggestion! We will contact you if and when we are able to add this provider to our network. In the meantime, you may want to look at the other providers that we have currently available in your area to get started.`
          );
        setShowModal(true);
      } else {
        //alert('Error: ' + result.Message);
        console.log("Error:",result.Message);
        setModalMessage(result.Message);
        setShowModal(true);
      }

      //onClose(); // Close modal after submission

    } catch (error) {
      console.error('Error submitting form:', error);
      setModalMessage("Failed to submit the form.");
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  };
  const handleModalClose = () => {
    onClose(); // Close modal after submission
    setFormData({
        GroupName: '',
    ProviderName: '',
    Address: '',
    PointofContact: '',
    ProviderEmail: '',
    ProviderPhoneNumber: '',
    Website: '',
    FirstName: formData.FirstName,
    LastName: formData.LastName,
    DOB: formData.DOB,
    PhoneNumber: formData.PhoneNumber,
    EmailID: formData.EmailID,
      });
    setShowModal(false);
    setErrors({});
}
 if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }
const capitalizeFirstLetter = (value) => {
  if (!value) return value;
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="tracker-modal-content"
      overlayClassName="tracker-modal-overlay"
      shouldCloseOnOverlayClick={false}
    >
      <h2>{t('dontseeprovider')}</h2>
      <h2>{isHighmarkPortal? t('highmarksubmitrequest'): t('submitrequest')}</h2>
      <div className="model-form-wrapper">
        <div className="mb-4 row align-items-center">
          <label className="col-sm-4 model-form-label mandatory">{t('groupname')}</label>
          <div className="col-sm-6">
            <input
              type="text"
              name="GroupName"
              value={formData.GroupName}
              onChange={handleInputChange}
              placeholder={t('entergroupname')}
              className="form-control win-form-control mobile-view"
              maxLength="100"
            />
            {errors.GroupName && <span className="form-field-error-message">{errors.GroupName}</span>}
          </div>
        </div>
        <div className="mb-4 row align-items-center">
          <label className="col-sm-4 model-form-label mandatory">{t('nameofprovidergroup')}</label>
          <div className="col-sm-6">
            <input
              type="text"
              name={t('providername1')}
              value={formData.ProviderName}
              onChange={handleInputChange}
              placeholder={t('enterprovider')}
              className="form-control win-form-control mobile-view"
              maxLength="100"
            />
            {errors.ProviderName && <span className="form-field-error-message">{errors.ProviderName}</span>}
          </div>
        </div>
        <div className="mb-4 row align-items-center">
          <label className="col-sm-4 model-form-label mandatory">{t('address')}</label>
          <div className="col-sm-6">
            <input
              type="text"
              name="Address"
              value={formData.Address}
              onChange={handleInputChange}
              placeholder={t('enteraddress')}
              className="form-control win-form-control mobile-view"
              maxLength="150"
            />
            {errors.Address && <span className="form-field-error-message">{errors.Address}</span>}
          </div>
        </div>
        <div className="mb-4 row align-items-center">
          <label className="col-sm-4 model-form-label mandatory">{t('pointofcontact1')}</label>
          <div className="col-sm-6">
            <input
              type="text"
              name="PointofContact"
              value={formData.PointofContact}
              onChange={handleInputChange}
              placeholder={t('entercontactperson')}
              className="form-control win-form-control mobile-view"
              maxLength="50"
            />
            {errors.PointofContact && <span className="form-field-error-message">{errors.PointofContact}</span>}
          </div>
        </div>
        <div className="mb-4 row align-items-center">
          <label className="col-sm-4 model-form-label mandatory">{t('provideremail1')}</label>
          <div className="col-sm-6">
            <input
              type="email"
              name="ProviderEmail"
              value={formData.ProviderEmail}
              onChange={handleInputChange}
              placeholder={t('enterprovideremail')}
              className="form-control win-form-control mobile-view"
              maxLength="50"
            />
            {errors.ProviderEmail && <span className="form-field-error-message">{errors.ProviderEmail}</span>}
          </div>
        </div>
        <div className="mb-4 row align-items-center">
          <label className="col-sm-4 model-form-label mandatory">{t('phonenumber')}</label>
          <div className="col-sm-6">
            <input
              type="text"
              name="ProviderPhoneNumber"
              value={formData.ProviderPhoneNumber}
              onChange={handleInputChange}
              placeholder={t('enterphone')}
              className="form-control win-form-control mobile-view"
              maxLength="50"
            />
            {errors.ProviderPhoneNumber && <span className="form-field-error-message">{errors.ProviderPhoneNumber}</span>}
          </div>
        </div>
        <div className="mb-4 row align-items-center">
          <label className="col-sm-4 model-form-label">{t('website')}</label>
          <div className="col-sm-6">
          <input
            type="url"
            name="Website"
            value={formData.Website}
            onChange={handleInputChange}
            placeholder={t('enterwebsiteurl')}
            className="form-control win-form-control mobile-view"
            maxLength="50"
          />
          {errors.Website && <span className="form-field-error-message">{errors.Website}</span>}
          </div>
        </div>

        <h2>{t('yourcontactdetails')}</h2>
        <div className="mb-4 row align-items-center">
          <label className="col-sm-4 model-form-label">{t('firstname')}</label>
          <div className="col-sm-6">
          <input
            type="text"
            name="FirstName"
             value={capitalizeFirstLetter(formData.FirstName)}
            onChange={handleInputChange}
            placeholder={t('enterfirstname')}
            className="form-control win-form-control mobile-view"
            maxLength="50"
            readOnly
          />
          {errors.FirstName && <span className="form-field-error-message">{errors.FirstName}</span>}
          </div>
        </div>
        <div className="mb-4 row align-items-center">
          <label className="col-sm-4 model-form-label">{t('lastname')}</label>
          <div className="col-sm-6">
          <input
            type="text"
            name="LastName"
            value={capitalizeFirstLetter(formData.LastName)}
            onChange={handleInputChange}
            placeholder={t('enterlastname')}
            className="form-control win-form-control mobile-view"
            maxLength="50"
            readOnly
          />
          {errors.LastName && <span className="form-field-error-message">{errors.LastName}</span>}
          </div>
        </div>
        <div className="mb-4 row align-items-center">
          <label className="col-sm-4 model-form-label">{t('dateofbirth')}</label>
          <div className="col-sm-7">
          <input
            type="date"
            name="DOB"
            value={formData.DOB}
            onChange={handleInputChange}
            className="form-control win-form-control calendar-control mobile-view"
            max={new Date().toISOString().split('T')[0]}
            readOnly
          />
          {errors.DOB && <span className="form-field-error-message">{errors.DOB}</span>}
          </div>
        </div>
        <div className="mb-4 row align-items-center">
          <label className="col-sm-4 model-form-label">{t('phonenumber')}</label>
          <div className="col-sm-7">
          <input
            type="text"
            name="PhoneNumber"
            value={formData.PhoneNumber}
            onChange={handleInputChange}
            placeholder={t('enterphonenumber')}
            className="form-control win-form-control mobile-view"
            maxLength="50"
            readOnly
          />
          {errors.PhoneNumber && <span className="form-field-error-message">{errors.PhoneNumber}</span>}
          </div>
        </div>
        <div className="mb-4 row align-items-center">
          <label className="col-sm-4 model-form-label">{t('emailid')}</label>
          <div className="col-sm-6">
          <input
            type="email"
            name="EmailID"
            value={formData.EmailID}
            onChange={handleInputChange}
            placeholder={t('enteremail')}
            className="form-control win-form-control mobile-view"
            maxLength="50"
            readOnly
          />
          {errors.EmailID && <span className="form-field-error-message">{errors.EmailID}</span>}
          </div>
        </div>
        <div className="mb-4 row align-items-center justify-content-end">
          <label className="col-sm-4 model-form-label"></label>
          <div className="col-sm-8 d-flex justify-content-start mb-3">
            <button className="win-btn-secondary model-popup-btn me-2 mb-3 mb-sm-0" onClick={onClose}>{t('close')}</button>
            <button className="win-btn-primary model-popup-btn" onClick={handleSubmit}>{t('submit')}</button>
          </div>
        </div>
      </div>
      
      <ErrorModal show={showModal} message={modalMessage} onClose={handleModalClose}  />
    </Modal>
  );
};

export default ProviderFormModal;
